<!--
  Skeleton — placeholder de carga de Otera. Reemplaza a SkeletonLegacy.
  Las dimensiones por variante igualan a los componentes que sustituyen
  (contrato CLS — NFR7).
-->

<script setup>
defineOptions({ name: 'DsSkeleton', inheritAttrs: false });

const props = defineProps({
  variant: {
    type: String,
    default: 'text-line',
    validator: (v) => ['panel', 'text-line', 'metric-anchor', 'chart'].includes(v)
  },
  width: { type: String, default: null },
  height: { type: String, default: null }
});

const styleOverride = {};
if (props.width) styleOverride.width = props.width;
if (props.height) styleOverride.height = props.height;
</script>

<template>
  <div
    class="ds-skel"
    :class="[`ds-skel--${variant}`]"
    :style="styleOverride"
    aria-hidden="true"
    v-bind="$attrs"
  />
</template>

<style scoped>
.ds-skel {
  background: linear-gradient(
    90deg,
    var(--bg-muted) 0%,
    var(--bg-active) 50%,
    var(--bg-muted) 100%
  );
  background-size: 200% 100%;
  border-radius: var(--radius-md);
  animation: ds-skel-pulse var(--motion-slow) ease-in-out infinite alternate;
}

@keyframes ds-skel-pulse {
  from {
  background-position: 200% 0;
}

  to {
  background-position: -200% 0;
}
}

@media (prefers-reduced-motion: reduce) {
  .ds-skel {
  animation: none;
}
}

.ds-skel--panel {
  width: 100%;
  height: 16rem;
}

.ds-skel--text-line {
  width: 100%;
  height: var(--text-base);
  border-radius: var(--radius-sm);
}

.ds-skel--metric-anchor {
  width: 6rem;
  height: var(--text-5xl);
}

.ds-skel--chart {
  width: 100%;
  height: 8rem;
}
</style>
